if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"cv_mfe_react","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 121 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}